import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
export default function Delivery() {
  const [MyWidth, setMyWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setMyWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, [MyWidth]);

  const { t, i18n } = useTranslation();
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
        paddingTop: 50,
        flexDirection: "column",
        paddingLeft: MyWidth <= 1024 ? "2%" : "0%",
        paddingRight: MyWidth <= 1024 ? "2%" : "0%",
        fontFamily: "Droid Arabic Kufi, sans-serif",
      }}
    >
      <a style={{ fontSize: 25, fontWeight: "500" }}>Lemaq Delivery</a>
      <div
        style={{
          //width: "80%",
          paddingTop: 20,
          display: "flex",
          flexDirection: "column",
          direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
        }}
      >
        <a>{t("delivery.Youwill")}</a>
        <a style={{ fontSize: 20, fontWeight: "500", paddingTop: 10 }}>
          {" "}
          {t("delivery.Thedelivery")}{" "}
        </a>
        <a style={{ paddingTop: 10 }}>
          {t("delivery.Yourparcelwillbedeliveredonaveragewithin")}
          <a style={{ fontSize: 20, fontWeight: "500" }}>
            {" "}
            {t("delivery.workingdays")}{" "}
          </a>{" "}
          {t("delivery.fromthedate")}{" "}
        </a>

        <a style={{ paddingTop: 10 }}>{t("delivery.Deliveryiscarried")}</a>
        <a style={{ paddingTop: 10 }}>{t("delivery.Aftertheorder")}</a>
        <a style={{ paddingTop: 10 }}>{t("delivery.Youwillreceive")}</a>
      </div>
    </div>
  );
}
